import { render, staticRenderFns } from "./questionDealType.vue?vue&type=template&id=24a3334e&scoped=true&"
import script from "./questionDealType.vue?vue&type=script&lang=js&"
export * from "./questionDealType.vue?vue&type=script&lang=js&"
import style0 from "./questionDealType.vue?vue&type=style&index=0&id=24a3334e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3334e",
  null
  
)

export default component.exports